import { jsx as _jsx } from "react/jsx-runtime";
import { TOP_VIDEO_PROPS } from "./dashboards-tab-consts.js";
import { withGenericConfig } from "/contexts/generic-config-context";
import LiveBoardTabComponent from "../live-board-tab-component";
const DashboardsTabContentComponent = (props)=>{
    const { translate, onCardClick } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: "dashboards-tab-content",
        children: /*#__PURE__*/ _jsx(LiveBoardTabComponent, {
            description: translate("liveBoard.dashboardsTab.description"),
            topAssetProps: TOP_VIDEO_PROPS,
            hideVideoControls: true,
            onAssetClick: onCardClick
        })
    });
};
export default withGenericConfig(DashboardsTabContentComponent);
